import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import { API, API_ROUTER } from '../../../../api'
import { MatchItem } from '../../../matches/components'
import { Card } from '../../../calendar/components/Card'
import { Preloader } from '../../../../components/UI'
import styles from './styles.module.scss'

export default function CupMatches() {
  const [matches, setMatches] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  let { id } = useParams()

  const getTournamentMatches = useCallback(() => {
    setIsLoading(true)
    API.request({
      ...API_ROUTER.tournaments.getTournamentMatches,
      pathKeys: {
        tournamentId: id,
      },
    })
      .then(res => {
        setMatches(res.matches || [])
      })
      .catch(err => {
        console.log(err)
        setMatches([])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [id])

  useEffect(() => {
    getTournamentMatches()
  }, [getTournamentMatches])

  const renderedMatches = useMemo(() => {
    return matches.map(match => (
      <Card key={match.matchId} className={styles.matchCard}>
        <MatchItem
          name={match?.name}
          tournamentLogo={match.tournament.logo}
          tournamentName={match.tournament.name}
          nameGame={match.game.name}
          gameLogo={match.game.logo}
          tournamentMember1={match.tournamentMember1 || 0}
          tournamentMember2={match.tournamentMember2 || 0}
          tournamentMemberScore1={match.tournamentMemberScore1}
          tournamentMemberScore2={match.tournamentMemberScore2}
          mode={match?.mode}
          groupsName={match.round.name}
          startedAt={match.startedAt}
          matchId={match.matchId}
          status={match.status}
          tournamentStageType={match.tournamentStageType}
          game={match.game}
          round={match.round}
        />
      </Card>
    ))
  }, [matches])

  return (
    <section className={styles.matchesList}>
      <div className={styles.matchesContainer}>
        {isLoading && !matches.length ? (
          <div className={styles.contentLoaderOverlay}>
            <Preloader />
            <div className={styles.loadingText}>
              <FormattedMessage id='common.loading' />
            </div>
          </div>
        ) : null}

        {matches.length > 0 ? (
          <div className={styles.matchesGrid}>{renderedMatches}</div>
        ) : !isLoading ? (
          <div className={styles.emptyData}>
            <FormattedMessage id='battlecup.matches.noMore' />
          </div>
        ) : null}
      </div>
    </section>
  )
}
